import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { startOfWeek, endOfWeek, eachDayOfInterval, format } from "date-fns";
import { LineChart, cheerfulFiestaPaletteDark } from "@mui/x-charts";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ResponsiveCharts from "../ChartsLayout/ResponsiveCharts.jsx";
import CustomGridItem from "../ChartsLayout/CustomGridItem.jsx";
import {
  HiddenTypography,
  EmptyLineChart,
} from "../ChartsLayout/EmptyCharts.jsx";

export default function ConsumptionOverview({
  consumptionData,
  dailyCaloriesOverview,
  selectedWeek,
}) {
  // console.log("Calories data in Consumption overview", consumptionData);

  const weekStart = startOfWeek(selectedWeek, { weekStartsOn: 1 });
  const weekEnds = endOfWeek(selectedWeek, { weekStartsOn: 1 });

  const weekDays = eachDayOfInterval({ start: weekStart, end: weekEnds });
  const { t } = useTranslation("statistics");

  const filteredConsumptionData = consumptionData.filter(
    (item) => item.calories !== null
  );
  const formattedCaloriesData = filteredConsumptionData.map((data) => ({
    date: format(new Date(data.date), "yyyy-MM-dd"),
    calories: data.calories,
  }));
  // console.log("formattedCaloriesData", formattedCaloriesData);

  const getCaloriesDataForADate = (date) => {
    const dateFormatted = format(date, "yyyy-MM-dd");
    const dayCaloriesData = formattedCaloriesData.find(
      (data) => data.date === dateFormatted
    );
    return dayCaloriesData ? dayCaloriesData.calories : 0;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ResponsiveCharts>
        {({ chartWidth }) => (
          <CustomGridItem>
            <div ref={dailyCaloriesOverview}>
              <Typography
                sx={{
                  margin: {
                    xs: "20px 0",
                    sm: "20px 0",
                    md: "0 0 20px 0",
                    lg: "20px 0 0 20px",
                    xl: "20px",
                  },
                  textAlign: "center",
                }}
                variant="h6"
              >
                {t("charts.consumption.dailyCaloriesTitle")}
              </Typography>
              {weekDays.some((day) => getCaloriesDataForADate(day)) ? (
                <>
                  <HiddenTypography />
                  <LineChart
                    colors={cheerfulFiestaPaletteDark}
                    xAxis={[
                      {
                        scaleType: "band",
                        data: weekDays.map((day) => format(day, "EEE")),
                      },
                    ]}
                    series={[
                      {
                        data: weekDays.map((day) =>
                          getCaloriesDataForADate(day)
                        ),
                        area: true,
                        label: t("series.caloriesOfDay"),
                      },
                    ]}
                    width={chartWidth}
                    height={300}
                  />
                </>
              ) : (
                <EmptyLineChart weekDays={weekDays} chartWidth={chartWidth} />
              )}
            </div>
          </CustomGridItem>
        )}
      </ResponsiveCharts>
    </LocalizationProvider>
  );
}
